export enum CouponType {
    // INTEGRAL-积分;COUPONS-优惠券;THIRD_COUPONS-第三方优惠券;GIFT_CARD-礼品卡;
    INTEGRAL = 'INTEGRAL',
    COUPONS = 'COUPONS',
    THIRD_COUPONS = 'THIRD_COUPONS',
    GIFT_CARD = 'GIFT_CARD',
    CASH = 'CASH',
}

export type BonusTabs = 'referral' | 'cashback' | 'leaderboard';

export enum ShareType {
    // SHARER-分享者;RECEIVER-被分享者
    SHARER = 'SHARER',
    RECEIVER = 'RECEIVER',
}

export enum PlanType {
    // NORMAL-常规型;CAMPAIGN-活动型
    NORMAL = 'NORMAL',
    CAMPAIGN = 'CAMPAIGN',
}

export enum UseStatus {
    UNUSED = 'UNUSED',
    USED = 'USED',
    EXPIRED = 'EXPIRED',
}

export enum ShipmentStatus {
    tracking_added = 'tracking_added', // 运输商已经收到了下单信息，并准备取包裹。
    confirmed = 'confirmed', // 运输商已经收到了下单信息，并准备取包裹。
    ready_for_pickup = 'ready_for_pickup', // 您的包裹已到达当地快递点，等待您去取件。
    failure = 'failure', // 可能异常
    in_transit = 'in_transit', // 您的包裹正在运输途中。
    delayed = 'delayed', // 运输过久
    out_for_delivery = 'out_for_delivery', // 您的订单正在给您派送的路上。
    attempted_delivery = 'attempted_delivery', // 您的订单正在给您派送的路上。
    undelivered = 'undelivered', // 您的包裹尝试派送但未能成功交付
    delivered = 'delivered', // 您的包裹已经成功签收。
}

export enum FulfillmentStatus {
    fulfilled = 'fulfilled', // 已发货
    partial = 'partial', // 未发货取消订单
    restocked = 'restocked', // 发货后退款
}

export enum AwardStatus {
    // DELAYED-延迟发放;RECEIVED-已发放
    DELAYED = 'DELAYED',
    RECEIVED = 'RECEIVED',
}

export enum AwardType {
    // REGISTER-注册成功;FIRST_PURCHASE-首次购买成功;REGISTER_EXTRA-注册额外奖励;EDM-订阅
    REGISTER = 'REGISTER',
    FIRST_PURCHASE = 'FIRST_PURCHASE',
    REGISTER_EXTRA = 'REGISTER_EXTRA',
    EDM = 'EDM',
}

export type IRules = {
    amount: string;
    currency: string;
    currencySymbol: string;
    discountType: string;
    endTime: string;
    extRuleDesc: string;
    goodId: string;
    goodSite: string;
    goodTitle: string;
    goodType: string;
    jumpUrl: string;
    picUrl: string;
    prerequisite: string;
    prerequisiteRange: string;
    ruleDescription: string;
    rulePic: string;
    source: string;
    startTime: string;
    useUrl: string;
    variantId: string;
    variantTitle: string;
};

export type ICouponDetail = {
    awardStatus: AwardStatus;
    awardType: AwardType;
    coupon: string;
    discountName: string;
    email: string;
    fulfillmentStatus: FulfillmentStatus;
    orderId: string;
    orderName: string;
    points: number;
    prizeLogId: string;
    prizeName: string;
    prizeType: CouponType;
    rules: IRules;
    shareType: ShareType;
    shipmentStatus: ShipmentStatus;
    useStatus: UseStatus;
    money?: string;
};

export type IRankItem = {
    prizeName: string;
    ranking: number;
    url: string;
    conditionDesc: string;
};

// 个人积分
export interface IUserPointsInfo {
    purchaseCount: string;
    registerCount: string;
}

// 个人钱包
export type IUserWalletInfo = IWalletItem & {
    withdrawalCurrencySymbol: string;
    withdrawalMinAmount: number;
};

// 裂变计划详情
export interface ICurrentPlanInfo {
    campaignEndTime: string;
    campaignStartTime: string;
    limitPoints: string;
    limitPointsFlag: boolean;
    planId: string;
    planType: PlanType;
    planName: string;
    prerequisite: string;
    prerequisiteRange: number;
    rankList: IRankItem[];
    receiveTc: string;
    registerEndTime: string;
    registerStartTime: string;
    registerTimeFlag: boolean;
    shareTc: string;
    subTitle: string;
    title: string;
    rankRuleDesc: string;
    label: string;
    personCenterTitle: string;
    personCenterSubTitle: string;
}

export interface ICurrentPlanTop {
    email: string;
    ranking: number;
    registerCount: number;
    userId?: string;
}

export interface ILeaderboard {
    awardIssueTime: string;
    awardStatus: string;
    prizeNames: string;
    ranking: number;
    statDate: string;
}

export interface IShareInfo {
    inviteCode: string;
    shareId: string;
}

export interface IBlogItem {
    moduleName: string;
    title: string;
    imgUrl: string;
    url: string;
}

export interface IProductItem {
    category: string;
    checkoutNode: string;
    compareAtPrice: string;
    imageUrl: string;
    memberPrice: string;
    price: string;
    productId: string;
    productUrl: string;
    purchaseUrl: string;
    subtitle1: string;
    subtitle2: string;
    title: string;
    variantId: string;
}

export interface IWalletItem {
    appid: string;
    availableAmount: number;
    currency: string;
    currencySymbol: string;
    email: string;
    freezingAmount: number;
    sourceService: string;
    userId: number;
    withdrawnAmount: number;
}

export interface IFaqInfo {
    faqModuleTitle: string;
    faqList: { faqContent: string; faqTitle: string }[]
}
